import { useConfig } from '@/contexts/ConfigContext';
import { useInstanceId } from '@/contexts/InstanceIdContext';

export const useParentUrl = () => {
  const { instanceId } = useInstanceId();
  const config = useConfig();

  const parentHost = config.PARENT_FRAME_ORIGIN;
  return `${parentHost}/${instanceId}`;
};
